module.exports = __webpack_public_path__ + "static/media/money.01c3baad.svg";